'use client';

import { useContext } from 'react';

import { UserSessionProviderContext } from '../providers/UserSessionProvider';

export function useUserSession() {
    const context = useContext(UserSessionProviderContext);

    if (context === undefined || context === null) {
        throw new Error('useUserSession must be used within a UserSessionProviderContext');
    }

    return context;
}
